const DownloadIcon = ({ height }) => (
  <svg
    height={height}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.291 5.91992C12.4088 6.10229 13.2735 7.1906 13.2735 9.57312V9.6496C13.2735 12.2792 12.2205 13.3322 9.59091 13.3322H5.76123C3.13163 13.3322 2.07861 12.2792 2.07861 9.6496V9.57312C2.07861 7.20825 2.93161 6.11994 5.01411 5.9258"
      stroke="#7E858F"
      strokeWidth="1.41186"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.67896 1.85938V9.43638"
      stroke="#7E858F"
      strokeWidth="1.41186"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.64971 8.125L7.67898 10.0957L5.70825 8.125"
      stroke="#7E858F"
      strokeWidth="1.41186"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DownloadIcon;
